import {
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
} from "ra-friendsofbabba";

import { Input } from "../../component/input";
import React from "react";

const UserResidenceInput = ({ label, ...props }) => (
  <Group wrapper {...props}>
    <GroupTitle title={label} />
    <Group>
      <GroupItem>
        <Input
          isRequired
          maxLength={100}
          source="user.profile.residence_place"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem lg={3} md={3} sm={3} xs={4}>
        <Input
          isRequired
          maxLength={3}
          source="user.profile.residence_province"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem lg={5} md={5} sm={8} xs={4}>
        <Input
          isRequired
          maxLength={100}
          source="user.profile.residence_address"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
    </Group>
  </Group>
);
export default UserResidenceInput;
